import { IModuleInitializerParams } from "@/Common/Modularity/ModuleInitializer";
import { ModuleInitializerBuilder } from "@/Common/Modularity/ModuleInitializerBuilder";
import { CanadaState } from "@/Common/Resources/Lookups/Enums/CommonLookupCodes";
import { ModuleNames } from "../ModuleNames";

/**
 * Determines if the Cnesst module should be loaded based on the clinic settings and addresses.
 * @param params The module initializer parameters.
 * @returns True if the Cnesst module should be loaded, false otherwise.
 */
function shouldLoadCnesstModule(params: IModuleInitializerParams): boolean {
    if (params.clinicSites.length === 0)
        return false;

    // at least one site must be in Quebec
    const quebecId = cacheStore.GetLookupIdForProvince(CanadaState.Quebec);
    for (const site of params.clinicSites) {
        for (const address of site.Model.Adresses || []) {
            if (address.StateLookupId === quebecId)
                return params.clinicSettings.EnableCnesst;
        }
    }

    return false;
}

const initializeCnesst = new ModuleInitializerBuilder()
    .withConditionalLoading(shouldLoadCnesstModule)
    .build(ModuleNames.Cnesst, async () => (await import("./CnesstModule")).default);

export default initializeCnesst;
